/**
 * ColetasConsolidadoReport - Collection orders at job level (paginated)
 */
import React from 'react';
import { RelatorioGeraisTable, type Column } from './RelatorioGeraisTable';

const columns: Column[] = [
  { key: 'data_hora', label: 'Data/Hora', width: '140px' },
  { key: 'ordem_coleta', label: 'O.C.', align: 'center', width: '90px' },
  { key: 'notas_fiscais', label: 'Notas Fiscais', width: '130px' },
  { key: 'receb_nf', label: 'Receb. NF', width: '110px' },
  { key: 'qtde', label: 'Qtde', align: 'right', format: 'decimal', width: '90px' },
  { key: 'status_armazem', label: 'Status do Armazém', width: '150px' },
  { key: 'data_devolucao', label: 'Data Devolução', width: '130px' },
];

interface Props {
  data: any[];
  loading?: boolean;
  totalRecords?: number;
  currentPage?: number;
  totalPages?: number;
  onPageChange?: (page: number) => void;
}

export const SolicitacaoColetaReport: React.FC<Props> = ({
  data,
  loading,
  totalRecords,
  currentPage,
  totalPages,
  onPageChange,
}) => {
  return (
    <RelatorioGeraisTable
      columns={columns}
      data={data}
      loading={loading}
      totalRecords={totalRecords}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
      emptyMessage="Nenhuma conferência avulsa encontrada no período selecionado."
    />
  );
};
